export class PutTableContextFileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "file",
            "baseName": "file",
            "type": "TableContextFile",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutTableContextFileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
